import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import ActiveLight from "components/UI/ActiveLight/ActiveLight";
import { apiGetTwsStatus, apiStartTws, apiStopTws } from "api/apiTws";
import { Button } from "antd";
import UpdateIBKRDetails from "components/UserSettings/UpdateIBKRDetails";

const TwsStatus = ({ ibcStatus, fetchIbAccountDetails }) => {
  const [twsStatus, setTwsStatus] = useState(false);

  const getTwsStatus = async () => {
    try {
      const isActive = await apiGetTwsStatus();
      setTwsStatus(isActive);
    } catch (err) {}
  };

  const onStartTws = async () => {
    try {
      await apiStartTws();
      setTimeout(() => {
        getTwsStatus();
      }, 500);
    } catch (err) {}
  };

  const onStopTws = async () => {
    try {
      const isActive = await apiStopTws();
      setTwsStatus(isActive);
    } catch (err) {}
  };

  useEffect(() => {
    getTwsStatus();
  }, []);

  const isConfigured = ibcStatus === "configured";

  return (
    <>
      <UpdateIBKRDetails
        completed={isConfigured}
        fetchIbAccountDetails={fetchIbAccountDetails}
      />
      {isConfigured && (
        <GenericCard title="TWS Status">
          {twsStatus ? (
            <div>
              <ActiveLight />

              <Button className="mt-4" onClick={onStopTws}>
                Stop TWS
              </Button>
            </div>
          ) : (
            <div>
              <h3 className="red">Off</h3>
              <Button className="mt-4" onClick={onStartTws}>
                Start TWS
              </Button>
            </div>
          )}
        </GenericCard>
      )}
    </>
  );
};

export default TwsStatus;

TwsStatus.propTypes = {
  ibcStatus: PropTypes.string,
  fetchIbAccountDetails: PropTypes.func,
};
